import Image from 'next/image'
import Link from 'next/link'

import Button from 'components/parts/button/button'
import WidthLimiter from 'containers/width-limiter/width-limiter'
import usePCWindow from 'hooks/usePCWindow'

import { imgInfo, logoAIBolit, points, iconData } from './data'
import { ScreenSize } from 'constants/media-constanst'

import styles from './intro-ai-bolit.module.scss'

const IntroAiBolit = () => {
  const isMobile = usePCWindow(ScreenSize.mobile)
  return (
    <WidthLimiter noBottomPadding noTopPadding>
      <div className={styles.flex}>
        {!isMobile ? (
          <div className={styles.imgInfoDesck}>
            <Image {...imgInfo.desktop} />
          </div>
        ) : (
          <Image className={styles.imgInfoMob} {...imgInfo.mobile} />
        )}
        <div>
          <div className={styles.title}>
            <Image className={styles.logo} {...logoAIBolit} />
            <h2>
              <p> AI Bolit</p>
            </h2>
          </div>
          <h2 className={styles.subtitle}>
            Инновационный сервис, разработанный специально для&nbsp;врачей
          </h2>
          <div className={styles.points}>
            {points.map((item, index) => {
              return (
                <div className={styles.point} key={index}>
                  <Image {...iconData} />
                  <p dangerouslySetInnerHTML={{ __html: item }}></p>
                </div>
              )
            })}
          </div>
          <Link href="/ai-medicus/landing" target="_blank">
            <Button modificator={styles.btnCheck}>Задать вопрос AI Bolit</Button>
          </Link>
        </div>
      </div>
    </WidthLimiter>
  )
}

export default IntroAiBolit
